<!--
`*lpxResponsive="'all md-none'"` mirrors the theme's own guard on its default mobile navbar.
ABP renders our replacement unconditionally, so without it the whole subtree — including a second
<app-notification> — would also be instantiated at desktop widths, where the bundle merely hides
  `.lpx-mobile-navbar-container`. This keeps it out of the DOM instead.
  -->
  <div class="lpx-mobile-navbar-container" *lpxResponsive="'all md-none'">
    <header class="lpx-mobile-navbar">
      <div class="lpx-logo-container">
        <lpx-brand-logo></lpx-brand-logo>
      </div>
      <div class="user-menu">
        @if (showNotification()) {
          <app-notification [isMobile]="true"></app-notification>
        }
        <lpx-icon iconClass="bi bi-person" role="button" (click)="toggleUserMenu()"></lpx-icon>
        <lpx-icon iconClass="bi bi-list" role="button" (click)="toggleNavbar()"></lpx-icon>
      </div>
    </header>

    <div class="user-menu-groups" [class.d-none]="userMenuHidden">
      <!--
      This is LeptonX Lite's MnUserProfileComponent markup inlined, NOT <lpx-mn-user-profile>.
      That component's template wraps everything in a literal `<ng-component *ngIf="...">` tag.
      `ng-component` is the implicit selector Angular gives a component declared without one — and
      MnUserProfileModule imports RouterModule, which brings the Router's selector-less
      ɵEmptyOutletComponent into scope. So the wrapper tag *instantiates* it, it renders a second
      <router-outlet>, the router fills that with the current route, and the profile markup below it
        is dropped as unprojected content. Net effect: the account panel showed a duplicate copy of
        the page and none of the account actions. Using <ng-container> avoids the collision.
        -->
        @if (user$ | async; as userProfile) {
          <div class="d-block">
            <div class="lpx-user-profile btn-toggle" role="button" (click)="toggleProfileMenu()">
              <lpx-avatar [avatar]="userProfile.avatar"></lpx-avatar>
              <span class="user-full-name">{{ userProfile.fullName }}</span>
            </div>
            @if (userProfile.userActionGroups) {
              <div class="action-group-menu" [class.d-none]="profileMenuHidden">
                @for (actionGroup of userProfile.userActionGroups; track actionGroup; let last = $last) {
                  @for (action of actionGroup; track action) {
                    <a
                      class="action"
                      role="link"
                      [routerLink]="action.link"
                      (click)="onActionClick(action)"
                      >{{ action?.text || '' | lpxTranslate | async }}</a
                      >
                    }
                    @if (!last) {
                      <div class="divider"></div>
                    }
                  }
                </div>
              }
            </div>
          }

          <lpx-mn-language-selection class="d-block"></lpx-mn-language-selection>
        </div>

        <nav class="lpx-mobile-nav-items" [class.d-none]="navItemsHidden">
          <lpx-navbar-routes
            [navbarItems]="navService.navbarItems$ | async"
            [routerItem]="true"
            (routeClick)="toggleNavbar()"
          ></lpx-navbar-routes>
        </nav>
      </div>
